export default __webpack_public_path__ + "img/7.asset.24077fa6.jpeg";